import { render, staticRenderFns } from "./modalPrint.vue?vue&type=template&id=2256ffb6"
import script from "./modalPrint.vue?vue&type=script&lang=js"
export * from "./modalPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports